import type { ReactElement } from "react";

import { useActiveOrganization } from "common/account/active_organization";
import { NetworkStatus, useQuery } from "util/graphql";
import LoadingIndicator from "common/core/loading_indicator";

import PaymentQuery, {
  type Payment_node_Organization,
  type Payment_node_Organization_defaultPaymentSource,
} from "../graphql/payment_query.graphql";

export type Organization = Payment_node_Organization;
export type PaymentSource = Payment_node_Organization_defaultPaymentSource | null;

export function usePaymentQuery(onComplete: (organization: Organization) => ReactElement) {
  const [activeOrganizationId] = useActiveOrganization();
  const { data, networkStatus } = useQuery(PaymentQuery, {
    variables: { organizationId: activeOrganizationId! },
  });
  if (!data || networkStatus === NetworkStatus.loading) {
    return <LoadingIndicator />;
  }

  if (data.node?.__typename !== "Organization") {
    throw new Error(`Expected organization, got ${data.node?.__typename}.`);
  }

  return onComplete(data.node);
}
